import React from 'react';
import lockedAccount from '../../styles/images/locked-account.svg';

function LockedAccountCard() {
  return (
    <>
      <div className="login-input-wrapper">
        <div className="title smaller">Account locked</div>
        <img
          className="login-status-img smaller"
          src={lockedAccount}
          alt="Big blue padlock"
        />
        <div className="subtitle center">
          Your account was locked after too many failed log in attempts. Check
          your inbox for a link to unlock it.
        </div>
      </div>
      <div className="floating-login-footer">
        Forgot your password?{' '}
        <a href="#app" className="request-new-pw">
          Reset password
        </a>
      </div>
    </>
  );
}

export default LockedAccountCard;
